import { useI18n } from "@/context/I18nContext";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle, Car, CalendarOff, UserX, CheckCircle2 } from "lucide-react";

const ICONS = { double_book: UserX, travel: Car, leave: CalendarOff, availability: AlertTriangle };

export default function WarningsPanel({ warnings, onFocus }) {
  const { t } = useI18n();
  return (
    <Card className="border-slate-200 p-4" data-testid="warnings-panel">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="h-4 w-4 text-amber-500" />
        <h3 className="font-semibold text-slate-900 text-sm">{t("cal.warnings", "Scheduling warnings")}</h3>
        {warnings.length > 0 && <Badge className="bg-amber-500">{warnings.length}</Badge>}
      </div>
      {warnings.length === 0 ? (
        <p className="text-sm text-slate-500 flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-500" />{t("cal.noWarnings", "No conflicts detected.")}</p>
      ) : (
        <div className="space-y-2 max-h-[320px] overflow-y-auto">
          {warnings.map((w, i) => {
            const Icon = ICONS[w.type] || AlertTriangle;
            return (
              <button key={i} data-testid={`warning-item-${w.type}`}
                onClick={() => onFocus?.(w)}
                className="w-full text-left flex gap-2 rounded-lg border border-slate-100 p-2 hover:bg-slate-50">
                <Icon className={`h-4 w-4 shrink-0 mt-0.5 ${w.severity === "high" ? "text-red-500" : "text-amber-500"}`} />
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-slate-800">{t(`cal.warn.${w.type}`, w.type)} · {w.workerName || "—"}</p>
                  <p className="text-[11px] text-slate-500">{w.date} — {w.detail}</p>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </Card>
  );
}
